import Picture from './Picture.vue';

export default Picture;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/components/picture/index.ts